import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { moduleActions } from '../module/module.actions';
import { moduleMutations } from '../module/module.mutations';
import { moduleState } from '../module/module.state';

export default {
  namespaced: true,
  state: moduleState,
  actions: moduleActions,
  mutations: moduleMutations
} as ModuleTree<RootState>;
